module.exports = __webpack_public_path__ + "5359f289.svg";